export default __webpack_public_path__ + "static/media/delete.7daa0946.svg";